export default "__VITE_ASSET__DD1s_K7j__"